<div id="main">
    <header [class.hide]="!settings.headerVisible" class="bg-image">
        <mat-toolbar color="primary">
            <mat-toolbar-row>

                <app-main-menu></app-main-menu>
                <!-- <app-language-menu></app-language-menu>  language menu removed from the app. --> 

                <!-- This fills the remaining space of the current row -->
                <div fxFlex="1 1 auto" fxLayoutAlign="center">
                    <img src="../../assets/img/logo.svg" alt="logo" class="logo">
                </div>

                <button mat-icon-button 
                [style.visibility]="settings.showHeaderButtons ? '' : 'hidden'"                
                title="Add Appointment" (click)="findOpenSlot()">
                    <mat-icon>add_circle</mat-icon>
                </button>

            </mat-toolbar-row>
            <mat-toolbar-row class="h-auto">
                <!-- <div style="width: 40px">&nbsp;</div> this spacer is need when language bar is displayed (currently removed from the app.)-->

                <div fxFlex="1 1 auto" fxLayoutAlign="center" class="mb-1">
                    {{ 'APP.TITLE' | translate}}
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </header>
    
    <!-- Child-->
    
    <router-outlet></router-outlet> 
   
</div>